<script lang="ts">
import Vue, { computed, defineComponent, ref } from "vue"
import { useStore } from "@/utils/vuex-utils"
import { User } from "@/types/user"
import axios from "axios"
import ThemedLoading from "@/components/ThemedLoading.vue"

export default defineComponent({
    name: "MarketingConsentBanner",
    components: { ThemedLoading },
    setup() {
        const store = useStore()
        const isLoading = ref<boolean>(false)

        const user = computed<User | null>(() => store.getters["auth/user"] as User | null)
        const siteInfo = computed(() => store.getters["siteInfo/siteInfo"])
        const showConsentBanner = computed<boolean>(() => {
            //never show for oems, only for reduxi
            if (siteInfo.value?.productName !== "Reduxi") return false

            return !!(user.value && user.value.marketingConsent === null)
        })

        const onButtonClick = async (type: "agree" | "disagree") => {
            isLoading.value = true

            try {
                await axios.post("/auth/user", {
                    data: {
                        ...user.value,
                        spotRegion: {
                            //@ts-ignore
                            code: user.value.eicCode?.code,
                            //@ts-ignore
                            type: user.value.eicCode?.type,
                        },
                        eicCode: null,
                        agileRegion: null,
                        marketingConsent: type === "agree",
                    },
                })

                //@ts-ignore
                await Vue.auth.fetch({})
            } catch (error) {
                console.log(error)
            } finally {
                isLoading.value = false
            }
        }

        return {
            showConsentBanner,
            onButtonClick,
            isLoading,
        }
    },
})
</script>

<template>
    <div class="consent-banner" v-if="showConsentBanner">
        <ThemedLoading :active="isLoading" :is-full-page="false" />
        <div>
            <p class="consent-banner-description">
                {{ $t("marketingConsent") }}
            </p>
            <div class="consent-banner-actions">
                <button class="btn btn-secondary" @click="() => onButtonClick('disagree')">
                    {{ $t("Disagree") }}
                </button>
                <button class="btn btn-sm btn-primary" @click="() => onButtonClick('agree')">
                    {{ $t("Agree") }}
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.consent-banner {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 150;
    background: #242424;
    border-top: 4px solid var(--theme-shade);
    padding: 20px;

    .consent-banner-description {
        color: #fff;
    }

    .consent-banner-actions {
        display: flex;
        justify-content: flex-end;
        gap: 20px;
    }
}
</style>
